export default __webpack_public_path__ + "static/media/family.683b4999.svg";